import axios from "axios";
import {FETCH_USER, FETCH_USER_ERROR} from "./types";

export const fetchUser = () => async (dispatch) => {
    //if action returns a function instead of an object
    //thunk will react and execute the function
    //passing through the dispatch actions
    try {
        const res = await axios.get('/api/current_user');
        dispatch({type: FETCH_USER, payload: res.data});
    } catch (e) {
        dispatch({
            type: FETCH_USER_ERROR,
            error: "Error fetching user"
        });
    }
};

export const handleToken = (token) => async (dispatch) => {
    try {
        const res = await axios.post('/api/stripe', token);
        dispatch({type: FETCH_USER, payload: res.data});
    }catch (e) {
        dispatch({
            type: FETCH_USER_ERROR,
            error: "Error transaction"
        });
    }
}